@file:OptIn(InternalResourceApi::class)

package top.design_system.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.design_system.generated.resources/"

@delegate:ResourceContentHash(2_630_183)
public val Res.string.app_name_short: StringResource by lazy {
      StringResource("string:app_name_short", "app_name_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 26),
      ))
    }

@delegate:ResourceContentHash(1_869_308_220)
public val Res.string.error_alert_title: StringResource by lazy {
      StringResource("string:error_alert_title", "error_alert_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37, 77),
      ))
    }

@delegate:ResourceContentHash(-1_357_034_997)
public val Res.string.otp_label: StringResource by lazy {
      StringResource("string:otp_label", "otp_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115, 45),
      ))
    }

@delegate:ResourceContentHash(-1_703_069_648)
public val Res.string.otp_resend: StringResource by lazy {
      StringResource("string:otp_resend", "otp_resend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 161, 66),
      ))
    }

@delegate:ResourceContentHash(1_736_547_955)
public val Res.string.otp_timer_prefix: StringResource by lazy {
      StringResource("string:otp_timer_prefix", "otp_timer_prefix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228, 64),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name_short", Res.string.app_name_short)
  map.put("error_alert_title", Res.string.error_alert_title)
  map.put("otp_label", Res.string.otp_label)
  map.put("otp_resend", Res.string.otp_resend)
  map.put("otp_timer_prefix", Res.string.otp_timer_prefix)
}
